import useSymptomChecker from 'hooks/useSymptomChecker';
import { checkSpanishLocale, cn, extractLabelAndComment } from 'lib/utils';
import { useEffect, useMemo, useState } from 'react';
import { useSymptomStore } from 'store/symptom';
import SymptomContainer from './components/SymptomContainer';
import { motion } from 'framer-motion';
import Checkmark from 'pages/profile/questionnaire/components/Checkmark';

export default function SymptomDuration() {
  const questionData = useSymptomStore((store) => store.questionData)?.data;

  const isSpanish = checkSpanishLocale();

  const { onSubmit, isLoading } = useSymptomChecker();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const englishChoices = JSON.parse(questionData?.eng_choices || '[]');
  const spanishChoices = JSON.parse(questionData?.spanish_choices || '[]');

  const options = useMemo(
    () => (isSpanish ? spanishChoices : englishChoices),
    [englishChoices, isSpanish, spanishChoices]
  );

  useEffect(() => {
    if (questionData?.user_eng_choices || questionData?.user_spanish_choices) {
      const selected =
        questionData?.[isSpanish ? 'user_spanish_choices' : 'user_eng_choices'];
      const index = options.indexOf(selected);
      setSelectedIndex(index);
    }
  }, [questionData, isSpanish]);

  const onContinue = () => {
    const englishChoice = englishChoices[selectedIndex];
    const spanishChoice = spanishChoices[selectedIndex];

    onSubmit({
      eng_choices: englishChoice,
      spanish_choices: spanishChoice,
      questionData,
    });
  };

  return (
    <SymptomContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={4}
    >
      <div className='grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6'>
        {options.map((option: string, index: number) => {
          const isSelected = index === selectedIndex;
          const { label, comment } = extractLabelAndComment(option);
          return (
            <motion.div
              key={option}
              onClick={() => setSelectedIndex(index)}
              className={cn(
                'w-full border-[2px] rounded-2xl px-4 py-2 flex items-center justify-between cursor-pointer text-[#656D76] gap-4',
                isSelected && 'border-primary text-primary bg-[#E1EBFF]'
              )}
              whileTap={{ scale: 0.98 }}
            >
              <p className='text-sm leading-5'>
                {label} <span>{comment}</span>
              </p>

              <Checkmark isSelected={isSelected} />
            </motion.div>
          );
        })}
      </div>
    </SymptomContainer>
  );
}
